<span class="custom-text">{{ 'dataNumber' | transloco }}1</span>
<div class="w-5/6 pb-6">
    <app-select-by-group
        labelNoGroup="nonStandard"
        placeholder="selectData"
        [defaultValue]="firstInterstandardDepositDefaultValue()"
        [optionsByGroup]="firstOptionsByGroup()"
        (optionSelected)="selectFirstInterstandardDepositFolder($event)" />
</div>
@if (isLoading()) {
    <app-loading />
} @else {
    @if (!addLayerService.depositFolderByStandard()) {
        <span class="custom-text pb-6">{{ 'noInterstandardForOrga' | transloco }}</span>
    }
    <span class="custom-text">{{ 'dataNumber' | transloco }}2</span>
    <div class="w-5/6 pb-6">
        <app-select-by-group
            labelNoGroup="nonStandard"
            placeholder="selectData"
            [defaultValue]="secondInterstandardDepositDefaultValue()"
            [isDisabled]="
                !addLayerService.linkedStandards().length ||
                !addLayerService.secondInterstandardDepositFolderOptions().length
            "
            [optionsByGroup]="secondOptionsByGroup()"
            (optionSelected)="selectSecondInterstandardDepositFolder($event)" />
    </div>
    @if (
        addLayerService.selectedFirstInterstandardDepositFolder() &&
        !addLayerService.secondInterstandardDepositFolderOptions().length
    ) {
        <span class="custom-text">{{ 'noInterstandardForOrgaWithSelectedData' | transloco }}</span>
    }
}
